import { Params, ParamMap } from '@angular/router';

export const TEXT_FILTER_KEY = 'q';

export const toTextFilterParams = (args: { searchText?: string }): Params => ({
	[TEXT_FILTER_KEY]: args.searchText ? args.searchText : undefined,
});

export const toTextFilterListArgs = (
	paramMap: ParamMap
): { searchText?: string } =>
	paramMap.has(TEXT_FILTER_KEY)
		? {
				searchText: paramMap.get(TEXT_FILTER_KEY),
		  }
		: undefined;
